// extracted by mini-css-extract-plugin
export default {"GeneralError":"GeneralError_GeneralError__6OQtC","AlertSign":"GeneralError_AlertSign__QpvtC","Header":"GeneralError_Header__QFKdz"};